import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';
import { ShiftDigitalEnvironment } from './ShiftDigitalEnvironment';

export class ShiftDigital implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_SHIFT_DIGITAL;
  label: string = 'SHIFT Digital';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = true;

  getClientIdRegexp(): RegExp {
    return /^[A-Z]{3,}$/;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [
      {
        key: 'retailerId',
        label: 'Retailer ID',
        placeholder: 'Retailer ID',
        required: true,
      },
      {
        key: 'providerId',
        label: 'Provider ID',
        placeholder: 'Provider ID',
        required: true,
      },
      {
        key: 'environment',
        label: 'Environment',
        required: true,
        defaultValue: ShiftDigitalEnvironment.STAGING,
        options: [
          { value: ShiftDigitalEnvironment.STAGING, label: 'Staging' },
          { value: ShiftDigitalEnvironment.PRODUCTION, label: 'Production' },
        ],
      },
    ];
  }
}
